import $ from "jquery";
window.$ = window.jQuery = $;

import pagepiling from "pagepiling.js";
import LazyLoad from "vanilla-lazyload";

import "./scss/main.scss";

// home + loader

$(document).ready(function () {
  history.replaceState({}, document.title, window.location.href.split("#")[0]);

  setTimeout(() => {
    $("#pp-nav").append("<div class='mouse'><div></div></div>");
  }, 100);

  setTimeout(() => {
    $(".loader").addClass("loaded");
    $(".quote").removeClass("active");
    setTimeout(() => {
      $(".loader").fadeOut();
    }, 1000);
  }, 2700);
});

// lazyload
let images = document.querySelectorAll(".lazy");
new LazyLoad(images);

// sections
// $(window).bind("resize", function (e) {
//   if (window.RT) clearTimeout(window.RT);
//   window.RT = setTimeout(function () {
//     window.location.href = window.location.href.split("#")[0];
//   }, 1000);
// });

// let windowHeight = $(window).height();
let windowWidth = $(window).width();

var startPagePiling = function () {
  if (windowWidth >= 1200) {
    if ($(".container__fullpage").length > 0) {
      $(".container__fullpage").pagepiling({
        anchors: ["sec1", "sec2", "sec3", "sec4"],
        onLeave: function (index, nextIndex, direction) {
          if ($(".section__fullpage--gray").hasClass("active")) {
            $("#pp-nav").addClass("nav--white");
            $("header").addClass("header--white");
            $(".mouse").addClass("mouse--dark");
          } else {
            $("#pp-nav").removeClass("nav--white");
            $("header").removeClass("header--white");
            $(".mouse").removeClass("mouse--dark");
          }
        },
      });
    }
  }
};

$(document).ready(function () {
  startPagePiling();
  $("#pp-nav ul li a").attr("aria-label", "Sections");
});

// fonts animation
$(document).ready(function () {
  $(".h4-first--mask, .h5-first--mask").addClass("active");
});

// about
$(document).ready(function () {
  $(".section1__about--img img").addClass("active");
  $(".section0__about--text").addClass("active");
});

// desing
$(document).ready(function () {
  $(".section0__desing--img").addClass("active");
  $(".section0__desing--image").addClass("active");
});

// nav toggler
$(".nav__toggler").click(function () {
  $(this).toggleClass("active");
  $(".main__menu").toggleClass("active");
  $("header").toggleClass("menu--active");
});

// horizontal
if ($(".container__fullpage--horizontal").length > 0) {
  $(".container__fullpage--horizontal").pagepiling({
    direction: "horizontal",
    navigation: false,
  });
}

// view?
var isInViewport = function (elem) {
  var bounding = elem.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= -200 &&
    bounding.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right - 500 <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
};

function isInView(elem) {
  return $(elem).offset().top - $(window).scrollTop() - 300 < $(elem).height();
}

// scroll horizontal
var element = document.querySelectorAll(".img");

if (element) {
  let scrollSpeed = 100;
  let scroller = document.getElementById("scroll");
  if (scroller) {
    window.addEventListener(
      "mousewheel",
      (e) => {
        element.forEach((el) => {
          if (isInViewport(el)) {
            el.classList.add("active");
          } else {
            el.classList.remove("active");
          }
        });

        if (!e.deltaY) return;
        let scrollDirection = e.deltaY > 0 ? 1 : -1;
        scroller.scrollLeft += scrollSpeed * scrollDirection;
        let scrollLeft = Math.round(scroller.scrollLeft);

        let maxScrollLeft = Math.round(
          scroller.scrollWidth - scroller.clientWidth
        );

        if (
          (scrollDirection === -1 && scrollLeft > 0) ||
          (scrollDirection === 1 && scrollLeft < maxScrollLeft)
        )
          if (scrollDirection === -1 && scrollLeft > 0) {
            $(".scroll--horizontal").addClass("left");
          } else {
            $(".scroll--horizontal").removeClass("left");
          }

        return true;
      },
      false
    );
    window.addEventListener(
      "DOMMouseScroll",
      (e) => {
        element.forEach((el) => {
          if (isInViewport(el)) {
            el.classList.add("active");
          } else {
            el.classList.remove("active");
          }
        });

        var supportsWheel = false;

        if (e.type == "wheel") supportsWheel = true;
        else if (supportsWheel) return;

        var delta = (e.deltaY || -e.wheelDelta || e.detail) >> 10 || 1;

        if (!delta) return;
        let scrollDirection = delta > 0 ? 1 : -1;
        scroller.scrollLeft += scrollSpeed * scrollDirection;
        let scrollLeft = Math.round(scroller.scrollLeft);

        let maxScrollLeft = Math.round(
          scroller.scrollWidth - scroller.clientWidth
        );

        if (
          (scrollDirection === -1 && scrollLeft > 0) ||
          (scrollDirection === 1 && scrollLeft < maxScrollLeft)
        )
          if (scrollDirection === -1 && scrollLeft > 0) {
            $(".scroll--horizontal").addClass("left");
          } else {
            $(".scroll--horizontal").removeClass("left");
          }

        return true;
      },
      false
    );
  }
  $(document).ready(function () {
    element.forEach((el) => {
      if (isInViewport(el)) {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
    });
  });
}

// contact
$(document).ready(function () {
  if ($("body").hasClass("page-template-contact")) {
    $("header").addClass("header--contact");
    $("html").css("overflow", "auto");
  }
  $(".contact__img").addClass("active");
});

// mobile anim
var animateMobile = function () {
  // home
  if ($(".home").length > 0) {
    if (isInView($(".section__fullpage--gray"))) {
      $(".section__fullpage--gray")
        .closest(".section__fullpage--gray")
        .addClass("active");
    } else {
      $(".section__fullpage--gray").closest(".section").removeClass("active");
    }
    if (isInView($(".section2"))) {
      $(".section2").closest(".section").addClass("active");
    } else {
      $(".section2").closest(".section").removeClass("active");
    }
    if (isInView($(".section3"))) {
      $(".section3").closest(".section").addClass("active");
    } else {
      $(".section3").closest(".section").removeClass("active");
    }
  }
  // desing
  if ($(".desing").length > 0) {
    if (isInView($(".section1__desing--imgs"))) {
      $(".section1__desing--imgs").closest(".section").addClass("active");
    } else {
      $(".section1__desing--imgs").closest(".section").removeClass("active");
    }
    if (isInView($(".section2__desing"))) {
      $(".section2__desing").addClass("active");
    } else {
      $(".section2__desing").removeClass("active");
    }
  }
  // renovations
  if ($(".renovations").length > 0) {
    if (isInView($(".section1__renovations"))) {
      $(".section1__renovations").addClass("active");
    } else {
      $(".section1__renovations").removeClass("active");
    }
    if (isInView($(".section2__renovations"))) {
      $(".section2__renovations").addClass("active");
    } else {
      $(".section2__renovations").removeClass("active");
    }
  }
  // joinery
  if ($(".joinery").length > 0) {
    if (isInView($(".section1__joinery"))) {
      $(".section1__joinery").addClass("active");
    } else {
      $(".section1__joinery").removeClass("active");
    }
  }
  // about
  if ($(".about").length > 0) {
    if (isInView($(".section2__about"))) {
      $(".section2__about").addClass("active");
    } else {
      $(".section2__about").removeClass("active");
    }
    if (isInView($(".section3__about"))) {
      $(".section3__about").addClass("active");
    } else {
      $(".section3__about").removeClass("active");
    }
    if (isInView($(".section4__about"))) {
      $(".section4__about").addClass("active");
    } else {
      $(".section4__about").removeClass("active");
    }
  }
};

$(window).scroll(function () {
  animateMobile();
});

// final log
// console.log(
//   "%c All processes runs ok or they seems like 🙈 🙉 🙊, greetings from VoilaStudio.pl",
//   "font-size: 14px; background: #fff; color: #000; padding: 20px; border: 5px solid #000;"
// );
